module.exports = __webpack_public_path__ + "static/media/sideimg.62683973.png";